export type ProductLineItemState = {
  lineItemQuantity: number;
  isSkuCapReached: boolean;
  adjustedQuantity: number;
  hasValidated: boolean;
  hasGenericError: boolean;
};

export enum ProductLineItemActionType {
  SET_LINE_ITEM_QUANTITY = 'setLineItemQuantity',
  ADJUST_LINE_ITEM_QUANTITY = 'adjustLineItemQuantity',
  SET_IS_SKU_CAP_REACHED = 'setIsSkuCapReached',
  SET_ADJUSTED_QUANTITY = 'setAdjustedQuantity',
  SET_HAS_VALIDATED = 'setHasValidated',
  SET_HAS_GENERIC_ERROR = 'setHasGenericError',
}

export type ProductLineItemAction =
  | {
      type: ProductLineItemActionType.SET_LINE_ITEM_QUANTITY;
      value: number;
    }
  | {
      type: ProductLineItemActionType.ADJUST_LINE_ITEM_QUANTITY;
      value: number;
    }
  | {
      type: ProductLineItemActionType.SET_IS_SKU_CAP_REACHED;
      isSkuCapReached: boolean;
    }
  | {
      type: ProductLineItemActionType.SET_ADJUSTED_QUANTITY;
      adjustedQuantity: number;
    }
  | {
      type: ProductLineItemActionType.SET_HAS_VALIDATED;
      hasValidated: boolean;
    }
  | {
      type: ProductLineItemActionType.SET_HAS_GENERIC_ERROR;
      hasGenericError: boolean;
    };
